import { Component, Inject, Input, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { secureStorage } from '../shared/services/encryption/secureservice';
import { isPlatformBrowser, Location } from '@angular/common';
import { ApiService } from '../shared/services/apiService.service';
import { Subscription } from 'rxjs';
import { RootService } from '../shared/services/root.service';
import { BehaviourSubjectService } from '../shared/services/behaviour-subject.service';
import { ClevertapService } from '../shared/services/clevertap/clevertap.service';
import { WishlistService } from '../shared/services/wishlist.service';
import { HttpHeaders } from '@angular/common/http';
import { CookieService } from '../shared/services/cookie.service';
import { WebsocketService } from '../websocket.service';
import { RegexService } from '../shared/form-validation/regex.service';
import * as CryptoJS from "crypto-js";

@Component({
  selector: 'app-kyc-popup',
  templateUrl: './kyc-popup.component.html',
  styleUrls: ['./kyc-popup.component.scss']
})
export class KycPopupComponent implements OnInit {
  showModal = false;
  popupForm: FormGroup;
  queryObject:any={};
    isVerify: boolean = false;
    sub: Subscription = new Subscription();
    m: any;
s: any;
timeLeft: any;
showTick = false;
isVliadOtp: boolean = false;
  @Input() isTimer: boolean = false;
  showReject = false;
    showLinkExpired: boolean=false;
  isSocketConnected: boolean = false;
  userData: any;
  kycAddOne: any;
  kycAddrTwo: any;
  selectedAddressProof: any;
  selectedAddDocNo: string;
  isAddKYCDone: any;
  adhar: any;
  selectedIDProof: any;
  selectedIdDocNo: string;
  isIdKYCDone: any;
  pan: any;
  submitted: boolean = false;
  constructor(private fb: FormBuilder,private toastrService: ToastrService,private spinner: NgxSpinnerService,private activatedroute:ActivatedRoute,private localStorage: secureStorage,private location: Location,private router :Router,private apiService :ApiService, private storageService: RootService,private behaviourSubject: BehaviourSubjectService, @Inject(PLATFORM_ID) private platformId: Object,
private secureService: RootService,private cleverService: ClevertapService,private wishlistService: WishlistService,private ssrcookieService: CookieService,private websocketService :WebsocketService,private regexService:RegexService) {
    this.popupForm = this.fb.group({
      aadhar: ['', [Validators.required,Validators.pattern(this.regexService.Aadhar)]],
      pan: ['', [Validators.required, Validators.pattern('^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$'),this.panFourthCharValidator]],
    });
  }
  
   ngOnInit(): void {    
    const fullUrl = this.location.path(true);
  const encryptedValue = fullUrl.split('?')[1];
  this.selectedAddressProof = "aadhar_card"
    this.selectedIDProof = "id_pancard";

  let decoded = decodeURIComponent(encryptedValue);
  decoded = decoded.replace(/ /g, '+')
  let decodedObj = this.localStorage.decryptData(decoded)

  this.queryObject = {};
  let paramsmaps = decodedObj.split("&");
  this.getUserDetails();        
  paramsmaps.forEach(param => {
    let [key, value] = param.split("=");
    if (key && value !== undefined) {
      this.queryObject[key] = decodeURIComponent(value);
    }
  });
  

  this.websocketStatus(this.queryObject?.socket_id)
  if (this.queryObject.mobile_number) {
    this.checkExpiry();
  }    
  }

    websocketStatus(data: string): void {
  try {
    let req = {
      socket_id: data
    };

    this.sub.add(
      this.apiService.socketStatus(req).subscribe({
        next: (result) => {
          if (result.success) {
            this.isSocketConnected = result.data.is_connected;
            if (!this.isSocketConnected) {
              this.LinkExpired();
            }
          } else {
            this.isSocketConnected = false;
          }
        },
        error: (err) => {
          this.isSocketConnected = false;
          console.error(err);
        },
        complete: () => {
          // Optional: handle completion if needed
        }
      })
    );
  } catch (error) {
    this.isSocketConnected = false;
    console.error(error);
  }
}


  openModal() {
    this.showModal = true;
  }

  closeModal() {
    this.showModal = false;
    this.popupForm.reset();
  }
  onlyNumberKey(event: any) {
    return this.regexService.NumberKeyEvent(event);
  }

   onSubmit() {
    if (this.isVliadOtp) {
      // this.closeModal()
    }
  }



    

  startTimer(timeLeft: any) {
    this.timeLeft = timeLeft;
    const interval = setInterval(() => {
      this.isTimer = true;
      this.m = Math.floor(this.timeLeft / 60);
      this.s = this.timeLeft % 60;
      this.m = this.m < 10 ? '0' + this.m : this.m;
      this.s = this.s < 10 ? '0' + this.s : this.s;
      this.timeLeft--;
      if (this.timeLeft < 0) {
        this.isTimer = false;
        clearInterval(interval);
      }
    }, 1000);
  }

  LinkExpired(){
    this.showModal = false;
    this.showTick = false;
    this.showReject = false;
    this.showLinkExpired = true;
  }
  checkExpiry() {
    const currentTime = Math.floor(Date.now() / 1000); // current time in seconds
  
  
    if (currentTime > this.queryObject?.expires_at) {
      // expired
     this.LinkExpired();
    } else {
      this.openModal();
      // this.sentOtp(this.queryObject.mobile_number);
    }
  }
  checkTimeExpiry() {
    const currentTime = Math.floor(Date.now() / 1000); // current time in seconds
    if (currentTime > this.queryObject?.expires_at) {
      // expired
     this.LinkExpired();
     return;
    } 
  }
  notAllowSpace(event: any) {
  
    if ((event.target.selectionStart === 0 && event.which === 32) || event.key === '.') {
      event.preventDefault();
    }
}



 panFourthCharValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value?.toUpperCase();

  if (value && value.length >= 4 && value[3] !== 'P') {
    return { invalidFourthChar: true };
  }

  return null;
}


 get f(){
    return this.popupForm.controls
  }

   submitKYC() {
    this.submitted = true
    if (this.popupForm.controls['pan'].value === '' && this.popupForm.controls['aadhar'].value === '') {
      this.toastrService.warning("Please Enter Pan No and Aadhar No.");
      return this.showModal = true;
    } else {
      if ((this.userData.account_type === 'Individual') && this.popupForm.controls['pan'].value && this.popupForm.controls['aadhar'].value === '') {
        this.toastrService.warning("Please Enter Aadhar No");
        return this.showModal = true;
      }
       if ((this.userData.account_type === 'Individual') && this.popupForm.controls['pan'].value === '' && this.popupForm.controls['aadhar'].value) {
        this.toastrService.warning("Please Enter Pan No.");
        return this.showModal = true;
      }
    }

    if (this.selectedIDProof == 'id_pancard') {
      var pan = this.popupForm.controls['pan'].value.match(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/)
      
      if (pan == null) {
        this.toastrService.warning('Invalid format of Pan Number')
        return this.showModal = true;
      }
      const fourthChar = pan[0].charAt(3).toUpperCase(); // Index 3 = 4th character
      if (this.userData?.account_type === 'Individual' && fourthChar !== 'P') {
        this.toastrService.warning('4th character of PAN must be "P" for Individual account type');
        return this.showModal = true;
      }

      if (this.userData?.account_type !== 'Individual' && fourthChar === 'P') {
        this.toastrService.warning('4th character of PAN not be "P" for Company account type');
        return this.showModal = true;
      }
    }
    if ((this.userData.account_type === 'Individual') && this.selectedAddressProof == 'aadhar_card' ) {
      var adhar = this.popupForm.controls['aadhar'].value.match(/^\d{12}$/);
      if (adhar == null) {
        
        this.toastrService.warning('Invalid format of Aadhar Number')
        return this.showModal = true;
      }
    }
    var skey = "edp@$3#drishti"
    var salt = "dRishtI";
    var iterations = 128;
    var bytes = CryptoJS.PBKDF2(skey, salt, { keySize: 48, iterations: iterations });
    var iv = CryptoJS.enc.Hex.parse(bytes.toString().slice(0, 32));
    var key = CryptoJS.enc.Hex.parse(bytes.toString().slice(32, 96));
    var cipherpassword = CryptoJS.AES.encrypt( this.popupForm.controls['aadhar'].value, key, { iv: iv }).toString();
    var cipherpasswords = CryptoJS.AES.encrypt( this.popupForm.controls['pan'].value, key, { iv: iv }).toString();
    let req = {
      "address_proofs": false == false ? [
        {
          "data": "",
          "document_type": "Address Proof",
          "document_description": this.selectedAddressProof,
          "doc_number": this.popupForm.controls['aadhar'].value,
          "e-KYC": false
        }
      ] : [],
      "id_proofs": false == false ? [
        {
          "data": "",
          "document_type": "ID Proof",
          "document_description": this.selectedIDProof,
          "doc_number": this.popupForm.controls['pan'].value,
          "e-KYC": false
        }
      ] : [],
      socket_id: this.queryObject?.socket_id || '',
    }
    try {
      this.spinner.show()
      this.sub.add(this.apiService.uploadKYC(req).subscribe({
        next: (res: any) => {
          this.spinner.hide()
          if (res.success) {
            this.spinner.hide()
            this.closeModal()
            this.showTick = true;
            this.showModal = false;
            this.toastrService.success("KYC Submit Successfully")
            this.getUserDetails()
          }else if(res?.data?.msg === 'Link expired please request a new link.'){
              this.LinkExpired()
          }
          else {
            this.spinner.hide()
            this.showReject = true;
            this.showTick =false;
            this.showModal = false;
          }
        },
        error: () => {
          this.spinner.hide()
            this.isVerify = false;
            this.showReject = true;
            this.showModal = false;
            this.toastrService.warning(
              'Your account is locked due to multiple incorrect OTP. Please try after sometime'
            );
        },
        complete: () => {
          this.spinner.hide()
        }
      }))
    } catch (error) {
      this.spinner.hide();
      this.isVerify = false;
      this.showReject = true;
      this.showModal = false;
    }
  }

  onPanInput(event: any): void {
  // Convert to uppercase
  const input = event.target as HTMLInputElement;
  input.value = input.value.toUpperCase();
  this.popupForm.controls['pan'].setValue(input.value, { emitEvent: false });

  this.checkPanAadharValidity();
}

onAadharInput(event: any): void {
  const input = event.target as HTMLInputElement;
  this.popupForm.controls['aadhar'].setValue(input.value, { emitEvent: false });

  this.checkPanAadharValidity();
}

checkPanAadharValidity(): void {
  const panValid = this.popupForm.controls['pan'].valid;
  const aadharValid = this.popupForm.controls['aadhar'].valid;

  this.isVliadOtp = panValid && aadharValid;
}


   getUserDetails() {
    if (isPlatformBrowser(this.platformId)) {
    let res = true
    if (res) {
      this.sub.add(this.apiService.getUserData().subscribe({
        next: (response: any) => {
          this.userData = response["data"];
          this.kycAddOne = this.userData?.address_one
          this.kycAddrTwo = this.userData?.address_two
          if (this.userData?.user_documents) {
            for (let i = 0; i < this.userData.user_documents.length; i++) {
              if (this.userData.user_documents[i].document_description == "aadhar_card" || this.userData.user_documents[i].document_description == "adhar_card") {
                this.selectedAddressProof = this.userData.user_documents[i].document_description
                this.selectedAddDocNo = this.userData.user_documents[i].doc_number
                this.isAddKYCDone = false
                this.adhar = this.userData.user_documents[i].doc_number
                if(this.selectedAddDocNo === " "){
                this.selectedAddDocNo =   this.selectedAddDocNo.trim()
                }
              }
              else if (this.userData.user_documents[i].document_description == "id_pancard") {
                this.selectedIDProof = this.userData.user_documents[i].document_description
                this.selectedIdDocNo = this.userData.user_documents[i].doc_number
                this.isIdKYCDone = this.userData.user_documents[i].e_kyc
                this.pan = this.userData.user_documents[i].doc_number
              }
              else { }
            }
          }

        },
        error: () => {
        },
      })
      );
    } else {
      this.toastrService.warning('Kindly Login');
      this.router.navigate(['/login/']);
    }
  }
  }
}
